import React, { useEffect, useState } from "react";
import axiosInstance from "./api/axiosInstance";

const FALLBACK_PROVIDERS = [
  { value: "r2", label: "Cloudflare R2", configured: true },
  { value: "s3", label: "AWS S3", configured: true },
];

/** Where this client's uploaded files are stored. "" = the server default (STORAGE_BACKEND). */
function StorageProviderField({ value, onChange, controlClassName = "", savedValue = "" }) {
  const [info, setInfo] = useState({ default: null, providers: FALLBACK_PROVIDERS });

  useEffect(() => {
    let active = true;
    axiosInstance
      .get("/storage-providers")
      .then((res) => {
        if (active && res.data?.providers) setInfo(res.data);
      })
      .catch(() => {});
    return () => {
      active = false;
    };
  }, []);

  const defaultLabel = info.providers.find((p) => p.value === info.default)?.label;
  const changed = Boolean(savedValue) && value !== savedValue;

  return (
    <div className="form-group">
      <label>File Storage</label>
      <select
        name="storageProvider"
        className={controlClassName}
        value={value || ""}
        onChange={(e) => onChange(e.target.value)}
      >
        <option value="">{defaultLabel ? `Server default (${defaultLabel})` : "Server default"}</option>
        {info.providers.map((p) => (
          <option key={p.value} value={p.value} disabled={!p.configured && p.value !== savedValue}>
            {p.configured ? p.label : `${p.label} (not configured)`}
          </option>
        ))}
      </select>
      <small className="form-hint">
        {changed
          ? "New uploads go to the new storage. Files already uploaded stay where they are and keep working."
          : "Logos, attachments, ID proofs and marketing media for this client."}
      </small>
    </div>
  );
}

export default StorageProviderField;
